export default {
  tabs: {
    accounts: "账户",
    report_config: "报告配置",
    general: "通用",
    billing_notifications: "账单与通知",
    privacy: "隐私",
    help: "帮助",
    about: "关于",
  },
  general: {
    title: "通用设置",
    displaySettings: "显示设置",
    theme: "主题",
    primaryColor: "主色调",
    languageSettings: "语言设置",
    language: "语言",
    otherSettings: "其他设置",
    timezone: "时区",
    selectTimezone: "选择时区",
    dateFormat: "日期格式",
    selectDateFormat: "选择日期格式",
    numberFormat: "数字格式",
    selectNumberFormat: "选择数字格式",
    englishFormat: "英文格式",
    europeanFormat: "欧洲格式",
    spaceFormat: "空格格式",
  },
  account: {
    title: "账户设置",
    subtitle: "管理您的个人信息、安全设置和账户偏好",
    edit: "编辑",
    save: "保存更改",
    cancel: "取消",
    profile: {
      title: "个人信息",
      name: "姓名",
      email: "邮箱地址",
      email_tip: "邮箱地址无法更改",
      company: "公司",
      phone: "电话",
      phone_invalid: "电话号码格式无效",
      bio: "个人简介",
      website: "网站",
      website_invalid: "网站URL格式无效",
      location: "位置",
      position: "职位",
      validation_error: "表单验证失败，请检查您的输入",
      change_avatar: "更换头像",
      remove: "移除头像",
      save_success: "个人资料更新成功",
      avatar_format_error: "只能上传JPG/PNG文件！",
      avatar_size_error: "图片必须小于2MB！",
      avatar_upload_error: "头像上传失败",
      avatar_format_tip: "JPG/PNG格式",
      avatar_size_tip: "最大文件大小：2MB",
      name_placeholder: "输入您的姓名",
      company_placeholder: "输入您的公司",
      phone_placeholder: "输入您的电话号码",
      bio_placeholder: "介绍一下您自己",
      website_placeholder: "https://example.com",
      location_placeholder: "输入您的位置",
      position_placeholder: "输入您的职位",
    },
    security: {
      password_title: "密码设置",
      password_tip: "为了账户安全，建议定期更改密码",
      change_password: "更改密码",
      current_password: "当前密码",
      new_password: "新密码",
      confirm_password: "确认新密码",
      save_password: "保存密码",
      password_changed: "密码已更新",
      password_mismatch: "新密码与确认密码不匹配",
      password_incorrect: "当前密码不正确",
      password_required: "请填写所有密码字段",
      password_too_short: "密码长度至少8个字符",
      password_change_failed: "密码更改失败",
      two_factor_auth_title: "双因素认证",
      two_factor_auth: "双因素认证",
      two_factor_auth_desc: "添加额外的安全层，需要密码和设备验证码才能登录",
      two_factor_auth_coming_soon: "功能即将推出",
      current_password_placeholder: "输入当前密码",
      new_password_placeholder: "输入新密码",
      confirm_password_placeholder: "确认新密码",
    },
    login_activity: {
      title: "登录活动",
      manage: "管理",
      trust_device: "信任设备",
      logout_device: "注销设备",
      device_trusted: "设备 {location} 已被信任",
      device_logged_out: "已从设备 {location} 注销",
      showing_details: "显示 {location} 的详细信息 - IP: {ip}, 时间: {time}",
      manage_info: "管理 {location} 的登录活动",
      login_details: "登录详情",
      ip_address: "IP地址",
      time: "时间",
      isp: "互联网服务提供商",
      bot_score: "机器人评分",
      locations: {
        current: "当前设备",
      },
      suspicious: "可疑",
      mobile_device: "移动设备",
      api_client: "API客户端",
      trusted: "已信任",
      device: "设备",
      client: "客户端",
      unknown: "未知",
      risk_reasons: "风险原因",
      location: "位置",
      trust_failed: "信任设备失败",
      show_more: "显示更多 {0} 条",
      show_less: "收起",
    },
    danger: {
      title: "危险操作",
      delete_title: "删除账户",
      delete_desc: "永久删除您的账户和所有相关数据。此操作无法撤销。",
      confirm_title: "您确定要删除账户吗？",
      confirm_desc: "此操作将永久删除您的账户和所有相关数据。无法撤销。",
      confirm_email_tip: "要确认删除，请输入您的邮箱地址：",
      confirm_email_placeholder: "输入您的邮箱地址",
      confirm: "确认删除",
      cancel: "取消",
      delete_account: "删除账户",
      delete_success: "账户删除成功",
      email_mismatch: "邮箱地址不匹配。请输入正确的邮箱地址。",
    },
  },
  privacy: {
    title: "隐私设置",
    privacyPolicyAgreement: "隐私政策协议",
    privacyPolicyAgreementDesc: "您在注册账户时已同意我们的隐私政策",
    privacyPolicyAgreementInfo: "隐私政策协议无法撤销",
  },
  reportConfig: {
    colorPicker: {
      title: "颜色选择器",
    },
    currencyName: {
      EUR: "欧元 (€)",
      USD: "美元 ($)",
      GBP: "英镑 (£)",
    },
    fetchDataFailed: "获取数据失败",
    configSelection: "配置选择",
    default: "默认",
    professional: "专业",
    simple: "简洁",
    custom: "自定义",
    exportType: "导出类型",
    upgradeToUnlock: "升级以解锁此功能",
    commonSettings: "通用设置",
    tableHeaderFont: "表头字体",
    tableCellFont: "单元格字体",
    textFont: "文本字体",
    textColor: "文本颜色",
    tableHeaderBg: "表头背景",
    selectColor: "选择颜色",
    dataFormat: "数据格式",
    selectFormat: "选择格式",
    titleFontSize: "标题字体大小",
    watermarkFontSize: "水印字体大小",
    titleColor: "标题颜色",
    premiumTitleColorActive: "高级标题颜色已激活",
    blue: "蓝色",
    red: "红色",
    displayFields: "显示字段",
    showDate: "显示日期",
    showContact: "显示联系人",
    showEmail: "显示邮箱",
    showTitle: "显示标题",
    showEmissionDetails: "显示排放详情",
    showSummary: "显示摘要",
    showTotalDistance: "显示总距离",
    showProductionEmission: "显示生产排放",
    showTransportEmission: "显示运输排放",
    showTotalEmission: "显示总排放",
    showTax: "显示税费",
    showCompliance: "显示合规声明",
    privacyFields: "隐私字段",
    hideCompanyName: "隐藏公司名称",
    hideContact: "隐藏联系人",
    hideEmail: "隐藏邮箱",
    hideLogo: "隐藏公司Logo",
    hideWeight: "隐藏重量",
    premiumFeatures: "高级功能",
    generalConfig: "常规配置",
    language: "语言",
    selectLanguage: "选择语言",
    currency: "货币",
    selectCurrency: "选择货币单位",
    showLogo: "显示Logo",
    companyLogo: "公司Logo",
    logoSupportFormat: "支持格式：JPG, PNG, GIF, WEBP, 最大2MB",
    showCompany: "显示公司",
    companyName: "公司名称",
    enterCompanyName: "输入公司名称",
    customContact: "自定义联系人",
    enterContact: "输入联系人",
    customEmail: "自定义邮箱",
    enterEmail: "输入邮箱",
    customCompliance: "自定义合规声明",
    enterCompliance: "输入合规声明",
    customFooter: "自定义页脚",
    excelFontStyle: "Excel中的字体样式由默认设置控制",
    footerPlaceholder: "例如：TaxEcoBit CBAM合规报告",
    showEmissionChart: "显示排放图表",
    pdfAdvancedFeatures: "PDF高级功能",
    removeWatermark: "移除水印",
    showSignatureArea: "显示签名区域",
    removeQRCode: "移除二维码",
    logoPosition: "Logo位置",
    selectPosition: "选择位置",
    topLeft: "左上角",
    topRight: "右上角",
    borderStyle: "边框样式",
    none: "无",
    solid: "实线",
    premiumTitleColor: "高级标题颜色",
    customTableHeaderBg: "自定义表头背景",
    customWatermark: "自定义水印",
    enterWatermark: "输入水印内容",
    inviteText: "邀请文本",
    enterInviteText: "输入邀请文本",
    excelAdvancedFeatures: "Excel高级功能",
    columnWidth: "列宽",
    cellBackground: "单元格背景",
    mergeHeader: "合并表头",
    enableFilter: "启用筛选",
    addDigitalSignature: "添加数字签名",
    signatureContent: "签名内容",
    enterSignature: "输入签名内容",
    premiumFeaturesDesc: "这些高级功能可以提升您报告的专业性",
    upgradeMessage: "升级到高级版以解锁语言切换、自定义Logo等独家功能",
    lightGray: "浅灰色",
    darkGray: "深灰色",
    messages: {
      excelExportRequiresPro: "Excel导出需要专业版订阅，已切换为PDF",
      logoUploadFailed: "Logo上传失败",
      configSaveSuccess: "配置保存成功",
      configSaveFailed: "配置保存失败",
      imageFileOnly: "仅支持图像文件！",
      imageSizeLimit: "图像大小不得超过2MB！",
      fileReadFailed: "文件读取失败",
    },
  },
  billing: {
    title: "账单与通知",
    compliance: "合规要求",
    compliance_desc: "关键通知，无法禁用",
    service: "服务关键",
    service_desc: "建议保持启用",
    experience: "用户体验",
    experience_desc: "可选，可以关闭",
  },
  notification: {
    title: "通知设置",
    policy: "CBAM政策更新",
    policy_desc: "接收紧急的欧盟CBAM法规变更。合规和避免罚款所必需。",
    payment: "付款失败警报",
    payment_desc: "付款失败时立即通知，防止服务中断。",
    expiry: "套餐过期提醒",
    expiry_desc: "套餐过期前3天通知。及时续订以避免服务暂停。",
    quota: "配额警告",
    quota_desc: "当您使用月度计算量的80%时发出警报。避免意外限制。",
    ticket: "支持工单更新",
    ticket_desc: "支持工单状态变更时接收邮件更新。",
    referral: "推荐奖励",
    referral_desc: "成功推荐获得免费计算次数时通知您。",
  },
  info: {
    about_taxecobit: "关于TaxEcoBit",
    about_taxecobit_description:
      "TaxEcoBit是专为欧盟中小企业设计的工具，用于简化CBAM碳排放报告和合规。凭借超过90%的准确率，它能够快速计算和生成报告，帮助降低罚款风险（€1K–€10K）。",
    our_vision: "我们的愿景",
    our_vision_description:
      "我们的目标是通过创新解决方案赋能欧盟中小企业实现无缝CBAM合规，推动可持续增长并支持2026年可持续发展目标。",
    contact_us: "联系我们",
    follow_us: "关注我们：",
    version_info: "版本信息",
    version: "版本",
    last_updated: "最后更新",
    license: "许可证",
    copyright: "© 2025 TaxEcoBit。版权所有。",
  },
};
